/* Aflairza: keep the Kai discount progress bar right under the shade picker.
   Kai can inject its bar on its own (e.g. under the product gallery); this moves it into the
   "Discount Progress Bar" block slot, or hides the extra copy if the slot already shows one. */
(function () {
  var PAT = /(^|[\s_-])(kai|bmsm|buy[-_]?more|progress[-_]?bar|progressbar)/i;
  var SKIP = /swiper|af-|nr-|af_|announcement|shopify-section|shopify-block/i;
  function visible(el) { return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }
  function hasBar(slot) {
    if (!slot) return false;
    var r = slot.getBoundingClientRect();
    return r.height > 12;
  }
  function run() {
    var slot = document.querySelector('[id*="kai_progress_bar"]');
    if (!slot) return;
    var scope = document.getElementById('MainContent') || document.querySelector('main') || document.body;
    var all = scope.querySelectorAll('div,section,aside,span');
    var found = [];
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el === slot || slot.contains(el) || el.contains(slot)) continue;
      var sig = (el.id || '') + ' ' + (typeof el.className === 'string' ? el.className : '');
      if (!PAT.test(sig) || SKIP.test(sig)) continue;
      if (el.closest('.af-gallery__dots, .nr-sticky, .af-lb')) continue;
      var parentHit = false, p = el.parentElement;
      while (p && p !== scope) {
        if (found.indexOf(p) > -1) { parentHit = true; break; }
        p = p.parentElement;
      }
      if (!parentHit) found.push(el);
    }
    if (!found.length) return;
    if (hasBar(slot)) {
      found.forEach(function (el) { if (el.style.display !== 'none') el.style.display = 'none'; });
    } else {
      var el = found[0];
      if (visible(el) || el.children.length) slot.appendChild(el);
      for (var k = 1; k < found.length; k++) found[k].style.display = 'none';
    }
  }
  var t = null;
  function schedule() { if (t) return; t = setTimeout(function () { t = null; run(); }, 150); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { run(); }, 2500);
})();
